import { render, staticRenderFns } from "./BaseBoardOrder.vue?vue&type=template&id=0456d61a&"
import script from "./BaseBoardOrder.vue?vue&type=script&lang=js&"
export * from "./BaseBoardOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports